import { createContext } from 'react';
import { AuthenticateService, ConfigurationService } from '@ibe/tupvid-services';

export const authenticateService = new AuthenticateService();
export const AuthenticateContext = createContext<AuthenticateService>(authenticateService);
export const configurationService = new ConfigurationService();
